import React from 'react'
import { ColoredButton } from '../../packages/components/lib/ColoredButton/';
import { cls } from '../../packages/components';
import Translations from '../../requests/apa/Translator';

import './index.scss'

const ButtonFilter = (props) => {
    const { onModalFilter , navigation} = props;
    const className = 'btn-filter aaf_keyboard-tab aaf_keyboard-tab-transparent';
    return (
        <ColoredButton
            color="red"
            className={cls(className, 'focusable')}
            onClick={() => onModalFilter()}
            navigation={navigation}>
            {Translations.get('btn_filter', 'FILTRAR')}
        </ColoredButton>
    )
}

export default ButtonFilter


// WEBPACK FOOTER //
// ./src/components/ButtonFilter/index.jsx